'use strict';

angular.module('cgmemApp')
  .config(['$stateProvider', function ($stateProvider) {
    $stateProvider
      .state('passwordResetRequest', {
        url: '/password/requestReset',
        templateUrl: 'app/passwordResetRequest/passwordResetRequest.html',
        controller: 'PasswordResetRequestCtrl',
        controllerAs: 'rc'
      });
  }]);